<template>
  <div class="gatwayBg">
      <el-tabs  tab-position="left" >

      <el-tab-pane label="系统信息">
          <el-form   required-asterisk  :label-position="position" center label-width="120px" style="margin: 50px auto">
            <el-form-item label="系统信息:" >
              设备运行在线监测和预测性维护平台V1.0
            </el-form-item>
          </el-form>
      </el-tab-pane>

      <el-tab-pane label="密码设置" name="passwrod"  >
          <el-form ref="userPasswordForm" :model="userPasswordInfo" required-asterisk :label-position="position" :rules="passwordRules" center  label-width="120px" style="margin: 50px auto">
            <el-form-item label="用户名：" required prop="username">
              <el-input size="large" type="text" v-model="userPasswordInfo.username" maxlength="30" clearable style="width: 360px"></el-input>
            </el-form-item>
  
            <el-form-item label="原密码：" required prop="oldPassword">
              <el-input size="large" type="password" v-model="userPasswordInfo.oldPassword" maxlength="30" clearable style="width: 360px"></el-input>
            </el-form-item>
            <el-form-item required prop="newPassword" label="新密码：">
              <el-input size="large" type="password"  maxlength="30" v-model="userPasswordInfo.newPassword" clearable style="width: 360px"></el-input>
            </el-form-item>
            <el-form-item required prop="newPassword2" label="确认密码：">
              <el-input size="large" type="password"  maxlength="30" v-model="userPasswordInfo.newPassword2" clearable style="width: 360px"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button  type="primary" @click="settingPassword" >
                <i class="fa fa-check"></i>提交
              </el-button>
              <el-button @click="resetForm('passwordForm')" type="info" >
                <i class="fa fa-reply-all"></i>重置
              </el-button>
            </el-form-item>
          </el-form>
      </el-tab-pane>

    </el-tabs>
  </div>

</template>

<script>
  import {apiUsersPassWordUpdata,apiUserslist} from '@/api/api'
  import {useMutitabsStore} from "@/store/mutitabs";
  import {delCookie} from '@/utils/util'
  import CryptoJS from 'crypto-js';
 
  export default {
      name: "systemSetting",
      setup() {
            const mutitabsstore = useMutitabsStore()
            return { mutitabsstore}
      },
      data() {
          var validatePass1 = (rule, value, callback) => {
            // const pwdRegex = new RegExp('(?=.*[0-9])(?=.*[a-zA-Z]).{8,30}')
            if (value === '') {
              callback(new Error('请输入密码'))
            } else if (value === this.userPasswordInfo.oldPassword) {
              callback(new Error('原密码与新密码一致'))
            } else if (value.length < 4 || value.length >30) {
              callback(new Error('密码长度须在4-30个字符之间'))
            } else {
              if (this.userPasswordInfo.newPassword2 !== '') {
                this.$refs.userPasswordForm.validateField('newPassword2')
              }
              callback()
            }
          }
          var validatePass2 = (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请再次输入密码'))
            } else if (value !== this.userPasswordInfo.newPassword) {
              callback(new Error('两次输入密码不一致!'))
            } else {
              callback()
            }
          }
          var validatePass = (rule, value, callback) => {
            // if(this.adminInfo.password != ""){
            //   if (value === '') {
            //     callback(new Error('请输入原密码'))
            //   } else {
            //     const password = JSON.parse(JSON.stringify(value))    
            //     var md5Hash = CryptoJS.MD5(password);  
            //     var sha256Hash = CryptoJS.SHA256(md5Hash.toString());  
            //     if (sha256Hash.toString() !== this.adminInfo.password) {
            //       callback(new Error('原密码输入错误!'))
            //     } else {
            //       callback()
            //     }
            //   }
            // }else{
            //   callback(new Error('密码获取失败，请重新刷新页面！'))
            // }
              if (value === '') {
                callback(new Error('请输入原密码'))
              } else {
                callback()
              }
          }
          return{
            position: 'right',
            adminInfo:{
              id: -1,
              password:""
            },
            userPasswordInfo: {
              username: '',
              oldPassword: '',
              newPassword: '',
              newPassword2: ''
            },
            passwordRules: {
              username:     [{ required: true, message: '请输入用户名',trigger: 'blur'}],
              oldPassword:  [{ required: true, message: '请输入原密码', trigger: 'blur' }],
              newPassword:  [{ required: true, validator: validatePass1, trigger: 'blur' }],
              newPassword2: [{ required: true, validator: validatePass2, trigger: 'blur' }]
            }
          }
      },

      mounted () {
      //  this.getAdminInfo()
      },

      methods:{
          // getAdminInfo () {
          //   apiUserslist().then(res=>{
          //       if(res.data.code ==200) {
          //           for(let i = 0;i<res.data.data.items.length;i++){
          //             if(res.data.data.items[i].name == "admin"){
          //               this.adminInfo.id = res.data.data.items[i].id
          //               this.adminInfo.password = res.data.data.items[i].password
          //               break;
          //             }
          //           }
          //       }else{
          //           this.$message.warning(`获取用户信息失败`)
          //       }
          //   }) .catch(error => {  
          //       if(error.msg)
          //         this.$message.warning(`获取用户信息失败 : ${error.msg}`);  
          //       else if(error.message)
          //         this.$message.warning(`获取用户信息失败 : ${error.message}`);  
          //       else 
          //         this.$message.warning(`获取用户信息失败`); 
          //   });
          // },

          // 重置
          resetForm (name) {
            const _self = this
            _self.userPasswordInfo = {
              username: '',
              oldPassword: '',
              newPassword: '',
              newPassword2: ''
            }
          },

          /**
           * 重新设置密码
           */
          settingPassword () {
            const _self = this

            _self.$refs.userPasswordForm.validate((valid) => {
              if (valid) {
                apiUserslist().then(res=>{
                    if(res.data.code ==200) {
                        for(let i = 0;i<res.data.data.items.length;i++){
                          if(res.data.data.items[i].name == this.userPasswordInfo.username){
                            this.adminInfo.id = res.data.data.items[i].id
                            this.adminInfo.password = res.data.data.items[i].password
                            break;
                          }
                        }
                        if(this.adminInfo.id == -1){
                          this.$message.warning(`密码修改失败：用户名或密码错误！`);
                        }else{
                          const password = JSON.parse(JSON.stringify(this.userPasswordInfo.oldPassword))  
                          var md5Hash = CryptoJS.MD5(password);  
                          var sha256Hash = CryptoJS.SHA256(md5Hash.toString());  
                          if (sha256Hash.toString() !== this.adminInfo.password) {
                            this.$message.warning(`密码修改失败：用户名或密码错误！`);
                          } else {


                            const password = JSON.parse(JSON.stringify(_self.userPasswordInfo.newPassword))    
                            var md5Hash = CryptoJS.MD5(password);  
                            var sha256Hash = CryptoJS.SHA256(md5Hash.toString());  

                            var params = {
                              id : this.adminInfo.id,
                              password : sha256Hash.toString()
                            }

                            apiUsersPassWordUpdata(params).then(res=>{
                                if(res.code ==200) {
                                    this.$message.success(`密码设置成功`)
                                    this.relogin()
                                }else{
                                    this.$message.warning(`密码设置失败`)
                                }
                            }) .catch(error => {  
                                if(error.msg)
                                  this.$message.warning(`密码设置失败 : ${error.msg}`);  
                                else if(error.message)
                                  this.$message.warning(`密码设置失败 : ${error.message}`);  
                                else 
                                  this.$message.warning(`密码设置失败`); 
                            });

                          }
                        }
                    }else{
                        this.$message.warning(`密码修改失败`)
                    }
                }) .catch(error => {  
                    if(error.msg)
                      this.$message.error(`密码修改失败 : ${error.msg}`);  
                    else if(error.message)
                      this.$message.error(`密码修改失败 : ${error.message}`);  
                    else 
                      this.$message.error(`密码修改失败`); 
                });    

              } else {
                this.$message.error('表单校验失败，请检查')
                  }
              })
          },

          relogin(){
            const logout = async () => {
              this.mutitabsstore.logout('false')
              sessionStorage.clear()
              localStorage.clear()
              await delCookie('username')
              await delCookie('password')
              this.$router.push({ path: '/login' })
            }
            logout()
          },
      }
  }
</script>

<style scoped >
   .gatwayBg{
    height: 100vh;
    background: url("../../assets/bigscreen/block_bg.jpg") no-repeat;
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
    background-color: #fff;
    padding: var(--my-css-var-bg-padding);
  }
  .el-tabs .el-tabs__content{
    background-color: var(--el-bg-color) !important;
  }
  .el-tabs{
    background-color: var(--el-bg-color) !important;
  }
  ::v-deep(.el-tabs__header){
    margin-top: 20px !important;
    margin-bottom:20px !important;
  }


</style>
